/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useContext, useState } from "react";
import { Dimensions, Platform, StyleSheet } from "react-native";
import { useTheme } from "../../../../providers/theme";
import { TabViewV } from "../../../../widgets/TabViewV";
//import blueprint from "../config/default-blueprint.json";
import { Map } from "./Map";
//import { DescriptionMap } from "./DescriptionMap";

import { NoMap, ProvDetailInfo, ProvenanceMap } from "./components";
import { ProvenanceStepTitle } from "../ProvenanceStepTitle";

const is = require("is_js");
//const BP: any = blueprint.TabSection;

const initialLayout = { width: Dimensions.get("window").width };

interface ITabSection {
  onListItemPress?: (item: any) => void;
  provStepHeading?: string;
  aboutProvInfo?: string;
  provInfoList?: any[];
  geoJson?: any;
  bp?: string;
  defaultCenter?: any;
  defaultZoom?: number;
  googleMapAPIKey?: string;
  
  
}

export const TabSection = ({
  onListItemPress,
  provStepHeading,
  aboutProvInfo,
  provInfoList,
  geoJson,
  bp,
  defaultCenter,
  defaultZoom,
  googleMapAPIKey,
  
  
}: ITabSection): JSX.Element => {
  const [index, setIndex] = useState(0);

  const [routes, setRoutes] = useState([
    { key: "first", title: "INFO" },
    { key: "second", title: "MAP" },
  ]);

  const theme = useTheme();

  React.useEffect(() => {
    if (!!geoJson) {
      setRoutes([
        { key: "first", title: "INFO" },
        { key: "second", title: "MAP" },
      ]);
    } else {
      setRoutes([{ key: "first", title: "INFO" }]);
    }
  }, [geoJson]);

  const _renderScene = (route: any) => {
    switch (route?.key) {
      case "first":
        return _renderProdInfo(route?.key);
      case "second":
        return _renderOrgInfo(route?.key);
      default:
        return null;
    }
  };
  

  const _renderProdInfo = (routeKey: string) => {
    return (
      <ProvDetailInfo
        //title={provStepHeading}
        aboutProvInfo={aboutProvInfo}        
        provInfoList={provInfoList}
        onProvListItemPress={onListItemPress}
        bp={bp}
      />
      
    );
  };  

  const _renderOrgInfo = (routeKey: string) => {
    console.log(`geoJson ::`, geoJson);
    if (geoJson && is.existy(geoJson) && is.not.empty(geoJson)) {
      //return <DescriptionMap geoJsonData={geoJson} />;
      return <ProvenanceMap markers={geoJson} defaultCenter={defaultCenter} defaultZoom={defaultZoom} googleMapAPIKey={googleMapAPIKey} />;
    } else {
      return <NoMap />;
    }
  };

  return (
    <TabViewV
      swipeEnabled={false}
      navigationState={{ index, routes }}      
      renderScene={_renderScene}
      onIndexChange={setIndex}
      initialLayout={initialLayout}
      activeColor={theme?.colors?.primary}
      inactiveColor={"#808080"}
      tabBarStyle={StyleSheet.flatten([
        styles.tabbar,
        { backgroundColor: theme?.colors?.transparent },
      ])}
      labelStyle={StyleSheet.flatten([
        styles.label,
        {
          backgroundColor: theme?.colors?.transparent,
        },
      ])}
      indicatorStyle={StyleSheet.flatten([
        styles.indicator,
        {
          backgroundColor: theme?.colors?.primary,
          width: routes?.length > 1 ? "50%" : "100%",
        },
      ])}
      // scrollEnabled={true}
    />
  );
};

const styles = StyleSheet.create({
  tabbar: {
    ...Platform.select({
      ios: {
        shadowOpacity: 0,
      },
      android: {
        elevation: 0,
      },
    }),
  },
  label: {
    justifyContent: "center",
    alignItems: "center",
    // fontWeight: 'bold',
    //  color: "grey",
    margin: 0,
    ...Platform.select({
      ios: {},
      android: {},
    }),
  },
  indicator: {
    alignSelf: "center",
    backgroundColor: "grey",
    height: 2,
    width: "50%",
    //left: 55,
  },
});

TabSection.defaultProps = {} as Partial<ITabSection>;
